import { render, staticRenderFns } from "./ImoFalForm1MenuForm.vue?vue&type=template&id=c0e9e440"
import script from "./ImoFalForm1MenuForm.vue?vue&type=script&lang=js"
export * from "./ImoFalForm1MenuForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports